export default () => {

	const forms = document.querySelectorAll('.js-currency-form');
	if (!forms.length) return;

	forms.forEach(form => {
		const input = form.querySelector('.js-currency-field');
		const items = form.querySelectorAll('.js-currency-select-item');
		const save = form.querySelector('.js-currency-save');
		const close = form.closest('.popup').querySelector('.js-close-popup');

		items.forEach(item => {
			item.addEventListener('click', () => {
				items.forEach(prevItem => {
					if (prevItem == item) return;
					prevItem.classList.remove('active');
				});

				item.classList.add('active');

				input.value = item.dataset.value;
			})
		});

		save.addEventListener('click', e => {
			e.preventDefault();
			const click = new Event("click");
			close.dispatchEvent(click);
		});
	})

}
